import * as bootstrap from 'bootstrap'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Slider from "./components/Slider";
import Section from "./components/Section";
import FilterV2 from "./components/FilterV2";
import { scrollFadeIn } from "./components/scrollFadeIn";

import { convertRemToPixels } from "./utils/WWWFunctions";

import * as Filter from "./utils/Filter";

import JSShare from "js-share";

export default class Common {
  constructor() {
    window.addEventListener("resize", () => this.resize());

    this.updateVhCssVar()

    this.handleHeader()
    this.handleNavAction()
    this.handleHeaderSearch()

    this.handlePageHero()
    this.initHeroVideo()
    this.handleSliders()
    this.handleSectionModules()

    this.handleChangeListView()
    this.handleVideo()
    this.handleShare()

    this.handleSortTable()
    this.handleFilterV2()
    scrollFadeIn()
  }

  init() {
  }
  updateVhCssVar() {
    const header = document.querySelector('header')
    const footer = document.querySelector('footer')
    document.body.style.setProperty("--header-height", `${header.offsetHeight}px`);
    document.body.style.setProperty("--footer-height", `${footer.offsetHeight}px`);
  }

  handleChangeListView() {
    document.querySelectorAll('[js-change-view]').forEach((item, i) => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        const type = item.dataset.view
        const mainView = document.querySelector('.main-view')
        
        if (mainView.dataset.view != type) {
          item.closest('.views').querySelector('.active').classList.remove('active')
          item.classList.add('active')
          mainView.dataset.view = type
        }
      });
    });
  }

  handleVideo() {
    document.querySelectorAll('.www-video').forEach((item, i) => {
      item.querySelector('.layer').addEventListener('click', (e) => {
        e.preventDefault()
        item.classList.add('active')
        item.querySelector('video').play()
        item.querySelector('video').controls = true
      });
    });
  }

  handleShare() {
    document.querySelectorAll('.www-share a').forEach((item, i) => {
      item.addEventListener('click', function share(e) {
        e.preventDefault()
        JSShare.options.url = window.location.href
        return JSShare.go(this)
      });
    });
  }

  handleNavAction() {
    const el_nav = document.querySelector('nav')
    const el_header = document.querySelector('header')

    document.querySelectorAll('[js-nav-trigger]').forEach((item, i) => {
      item.addEventListener('click', () => {
        el_nav.classList.toggle('active')
        el_header.classList.toggle('active')
      })
    });

    document.querySelectorAll('[js-nav-subs-trigger]').forEach((item, i) => {
      item.addEventListener('click', () => {
        const links = item.closest('.nav--links')
        const group = item.closest('.row')
        if (group.classList.contains('active')) {
          links.classList.remove('active')
          group.classList.remove('active')
          gsap.to(group.querySelector('.subs'), {
            height: `0px`,
            duration: .35,
            onComplete: () => {
              links.style.minHeight = `0px`
            }
          })
        } else {
          if (links.querySelector('.nav--links .row.active')) {
            gsap.to(links.querySelector('.nav--links .row.active .subs'), {
              height: `0px`,
              duration: .35,
            })
            links.querySelector('.nav--links .row.active').classList.remove('active')
          }
          links.classList.add('active')
          group.classList.add('active')
          gsap.to(group.querySelector('.subs'), {
            height: `${group.querySelector('.subs ._wrap').offsetHeight}px`,
            duration: .35,
            onComplete: () => {
              links.style.minHeight = `${group.querySelector('.subs ._wrap').offsetHeight}px`
            }
          })
        }
      })
    });
  }

  handleHeader() {
    const el_header = document.querySelector('header')
    let prevScrollpos = window.pageYOffset;

    const sidebar = document.querySelector('.contents-sidebar-menu')
    const hero = document.querySelector('section#hero, section#heroSlider')

    let _this = this
    window.onscroll = function() {
      let currentScrollPos = window.pageYOffset;

      /* if scrolling down, let it scroll out of view as normal */
      let h = hero ? hero.offsetHeight : window.innerHeight
      // if mobile h = h / 2
        if (window.innerWidth < 768) {
          h = h / 2
        }

      if (currentScrollPos > h - el_header.offsetHeight) {
        el_header.classList.add('sd')
        // gsap.to(el_header, {
        //   y: -headerBottom,
        //   duration: .5
        // })

        // const event = new CustomEvent("handleContentSidebar", {
        //   detail: {
        //     type: 'top',
        //     val: -headerBottom
        //   }
        // });
        // document.dispatchEvent(event);
      }
      /* otherwise if we're scrolling up, fix the nav to the top */
      else {
        el_header.classList.remove('sd')
        // gsap.to(el_header, {
        //   y: 0,
        //   duration: .5
        // })

        // const event = new CustomEvent("handleContentSidebar", {
        //   detail: {
        //     type: 'top',
        //     val: 0
        //   }
        // });
        // document.dispatchEvent(event);
      }

      prevScrollpos = currentScrollPos;
    }
  }

  handleHeaderSearch() {
    let search_open = false
    const el_header = document.querySelector('header')
    const el_nav = document.querySelector('nav')
    const el_search_btn = document.querySelector('[js-header-search-btn]')

    el_search_btn.addEventListener('click', () => {
      if (search_open) {
          el_header.classList.remove('search-open')
          search_open = false
          return
      }
      el_header.classList.add('search-open')
      search_open = true
      if (el_header.classList.contains('active')) {
        el_header.classList.remove('active')
        el_nav.classList.remove('active')
      }
    })

    document.body.addEventListener('click', (e) => {
      if(e.target.closest('[js-header-search-btn]')) {
        return
      }
      if (!e.target.closest('.header-search') && search_open) {
        el_header.classList.remove('search-open')
        search_open = false
      }
    })
  }

  handleSliders() {
    const sliders = document.querySelectorAll('.www-slider')
    if (sliders.length) {
      sliders.forEach((item, i) => {
        const slider = new Slider(item)
        slider.init()
      });
    }
  }

  handleSectionModules() {
    const sections = document.querySelectorAll('.section-part')
    if (sections.length) {
      sections.forEach((item, i) => {
        const section = new Section(item)
        section.init()
      });
    }
  }

  handlePageHero() {
    const pageHero = document.querySelector('section#hero')
    if (pageHero) {
      gsap.fromTo(pageHero.querySelector('.main'), {
        opacity: 1,
      }, {
        opacity: 0,
        scrollTrigger: {
          trigger: pageHero.querySelector('.main'),
          start: "bottom 40%",
          end: "+=20%",
          scrub: true,
          ease: 'linear',
          // markers: true,
        }
      })
    }
  }

  initHeroVideo() {
    const MOBILE_BREAKPOINT = 768;
    let wasMobile = window.innerWidth < MOBILE_BREAKPOINT;

    const loadHeroVideos = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      document.querySelectorAll('.www-hero-video').forEach(video => {
        const src = (isMobile && video.dataset.mobileSrc)
          ? video.dataset.mobileSrc
          : video.dataset.desktopSrc;
        if (!src) return;
        const source = video.querySelector('source');
        if (source && source.src !== src) {
          source.src = src;
          video.load();
          video.play().catch(() => {});
        }
      });
    };

    loadHeroVideos();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
        if (isMobile !== wasMobile) {
          wasMobile = isMobile;
          loadHeroVideos();
        }
      }, 300);
    });
  }

  handleSortTable() {

    document.querySelectorAll('[js-table-sort]').forEach(item => {
      item.addEventListener('click', () => {
        const n = parseInt(item.dataset.sort)
        var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = item.closest('table')
        switching = true;
        // Set the sorting direction to ascending:
        dir = 'asc';
        console.log(dir);
        /* Make a loop that will continue until
        no switching has been done: */
        while (switching) {
          // Start by saying: no switching is done:
          switching = false;
          rows = table.rows;
          /* Loop through all table rows (except the
          first, which contains table headers): */
          for (i = 1; i < (rows.length - 1); i++) {
            // Start by saying there should be no switching:
            shouldSwitch = false;
            /* Get the two elements you want to compare,
            one from current row and one from the next: */
            x = rows[i].getElementsByTagName("TD")[n];
            y = rows[i + 1].getElementsByTagName("TD")[n];
            /* Check if the two rows should switch place,
            based on the direction, asc or desc: */
            if (dir == "asc") {
              if (x.dataset.sortValue.toLowerCase() > y.dataset.sortValue.toLowerCase()) {
                // If so, mark as a switch and break the loop:
                shouldSwitch = true;
                break;
              }
            } else if (dir == "desc") {
              if (x.dataset.sortValue.toLowerCase() < y.dataset.sortValue.toLowerCase()) {
                // If so, mark as a switch and break the loop:
                shouldSwitch = true;
                break;
              }
            }
          }
          if (shouldSwitch) {
            /* If a switch has been marked, make the switch
            and mark that a switch has been done: */
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            // Each time a switch is done, increase this count by 1:
            switchcount ++;
          } else {
            /* If no switching has been done AND the direction is "asc",
            set the direction to "desc" and run the while loop again. */
            if (switchcount == 0 && dir == "asc") {
              dir = "desc";
              switching = true;
            }
          }
        }

        item.dataset.dir = dir
      })
    })
  }

  handleFilterV2() {
    const filterForm = document.querySelector('.www-filter-v2')
    if (filterForm) {
        const filter = new FilterV2(filterForm)
        filter.init()
    }
  }



  resize() {
    this.updateVhCssVar()
  }
}
